<template>
  <e-chart
    :header="`${documentTitle}`"
    :options="chartProductionGarbageOptions"
    :series="chartKpGarbageSeries"
    class="item-large"
    chartId="garbageCalculation"
    :chartRedirectParams="chartRedirectParams"
    :chartLoading="chartLoading"
    :chartError="chartError"
    :alwaysDisableAnimation="true"
  >
    <template slot="exportData">
      <div class="chart-block__export-data">
        <div>{{ documentTitle }}</div>
        <div>
          Показатель:
          {{
            chartViewGarbageKp.find(
              (item) => item.id === fields.garbageKp.viewMode
            ).name
          }}
        </div>
        <div>Период: {{ fields.garbageProductionYear }}</div>
      </div>
    </template>
    <template slot="chartHeader">
      <div class="default-select part-1-from-1 chart-block__wide-select">
        <e-select
          @change="fetchData"
          tabView="tab1"
          :model="fields.garbageKp"
          name="viewMode"
          :options="chartViewGarbageKp"
        ></e-select>
      </div>
      <div class="default-select part-1-from-4">
        <e-select
          @change="fetchData"
          tabView="tab1"
          :model="fields"
          name="garbageProductionYear"
          :options="chartYearOptions"
        ></e-select>
      </div>
    </template>
  </e-chart>
</template>
<script>
import chartsMixin from '../mixins/charts-mixin'

export default {
  mixins: [chartsMixin],
  props: { limit: { type: Number, default: null } },
  computed: {
    viewMode: {
      get: function () {
        return this.$store.getters.charts.garbageKp.viewMode
      },
      set: function (newValue) {
        this.$store.commit('charts', { garbageKp: { viewMode: newValue } })
      },
    },
    getCurrentChartOptions() {
      return this.getChartOptions('garbageKp')
    },
  },
  methods: {
    buildEndpoint() {
      return this.getEndpoint()({
        query: {
          type: 'kp',
          year: this.fields.garbageProductionYear,
          viewMode: this.fields.garbageKp.viewMode,
        },
      })
    },
    fetchData() {
      this.fetchChartData().then((r) => {
        this.chartKpGarbageSeries = this.transform(r)
        this.createAndSetCats(r, this.chartKpGarbageSeries)
      })
    },
    createAndSetCats(r, series = []) {
      let cats = []
      let indexForPosition = 0
      let positions = []
      series[0].data.forEach((v) => {
        cats.push(`${v.name}`)
        positions.push(indexForPosition)
        indexForPosition++
      })
      let options = Object.assign({}, this.chartProductionGarbageOptions)
      options.xAxis.categories = cats
      options.xAxis.tickPositions = positions
      options.xAxis.max = this.limit
      this.chartProductionGarbageOptions = Object.assign({}, options)
    },
  },
  created() {
    this.chartProductionGarbageOptions = this.getCurrentChartOptions
    this.fetchData()
  },
}
</script>
